// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-10062cdc] .v-slider--horizontal{margin-left:unset;margin-right:unset}*[data-v-10062cdc] .v-slider--horizontal .v-slider__track-container{height:6px}*[data-v-10062cdc] .v-slider__track-background,*[data-v-10062cdc] .v-slider__track-fill{border-radius:2px}.forty-eight-percent-width[data-v-10062cdc]{width:48%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
